import isEmpty from 'lodash/isEmpty'
import { StrapiRichTextStyles } from '@/revamp/pods/strapi/components/strapi-rich-text-editor-styles'
import { populateHandleBarLikeTemplatesWithData } from '@/revamp/utils/string/handlebar-like-string-template-populate'
import Text from '@/stories/components/Common/NewText'

type Props = {
  question: string
  answer: string
  json_placeholder?: object
}

const questionSchemaProps = {
  itemScope: true,
  itemProp: 'mainEntity',
  itemType: 'https://schema.org/Question',
}

const answerSchemaProps = {
  itemScope: true,
  itemProp: 'acceptedAnswer',
  itemType: 'https://schema.org/Answer',
}

export function StrapiV4FAQv1(props: Props) {
  const { question, answer, json_placeholder = {} } = props

  const massagedAnswer = isEmpty(json_placeholder)
    ? answer
    : populateHandleBarLikeTemplatesWithData(answer, json_placeholder)

  return (
    <div {...questionSchemaProps}>
      <div className="border-b-1 mt-11 pb-8">
        <Text appearance="subtitle3" tag="h3" itemProp="name">
          {question}
        </Text>
        <div {...answerSchemaProps}>
          <div itemProp="text">
            <StrapiRichTextStyles>
              <div
                dangerouslySetInnerHTML={{
                  __html: massagedAnswer,
                }}
                className="text-base [&>p]:!leading-relaxed"
              />
            </StrapiRichTextStyles>
          </div>
        </div>
      </div>
    </div>
  )
}
